// extracted by mini-css-extract-plugin
var _1 = "FilePreview-moduleFilePreview__p3eDY";
var _2 = "FilePreview-modulebutton__LX8Vu";
var _3 = "FilePreview-modulemessage__kJzGN";
export { _1 as "FilePreview", _2 as "button", _3 as "message" }
